import React from 'react';
import PropTypes from 'prop-types';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import FormatDollarAmount from '../FormatDollarAmount.jsx';

function CommGrossQuotaBreakdownRow({ quota }) {
  const totalSamplesUsed = Math.abs(Number(quota.TotalSamplesUsed || 0));
  return (
    <TableRow>
      <TableCell>{quota.CATEGORY}</TableCell>
      <TableCell>
        <FormatDollarAmount amount={quota.Base} />
      </TableCell>
      <TableCell>
        <FormatDollarAmount amount={quota.TotalGrowth} />
      </TableCell>
      <TableCell>{quota.T_PCI}</TableCell>
      <TableCell>
        <FormatDollarAmount amount={quota.Tier2Start} />
      </TableCell>
      <TableCell>
        <FormatDollarAmount amount={quota.Tier3Start} />
      </TableCell>
      <TableCell>${Number(quota.D_Samp || 0).toFixed(3)}</TableCell>
      <TableCell>
        <FormatDollarAmount amount={quota.TotalSamples} />
      </TableCell>
      <TableCell>
        <FormatDollarAmount amount={totalSamplesUsed} />
      </TableCell>
      <TableCell>
        <FormatDollarAmount amount={quota.YearlyQuota} />
      </TableCell>
      <TableCell>
        <FormatDollarAmount amount={quota.EOYB} />
      </TableCell>
    </TableRow>
  );
}
CommGrossQuotaBreakdownRow.propTypes = { quota: PropTypes.object.isRequired };
export default React.memo(CommGrossQuotaBreakdownRow);
